
  import ContentDisplay from '@/components/content-display/content-display.vue'
  import CmsSectionItemList from '@/components/cms/cms-section-item-list/cms-section-item-list.vue'
  import { transformKeysDeep } from '@/assets/js/util/misc/transform'
  import { createHeadSeoData } from '~/assets/js/util/nuxt/seo'

  export default {
    components: { CmsSectionItemList, ContentDisplay },
    // @ts-ignore
    async asyncData({ $content, app, error, params }) {
      let page

      try {
        page = await $content('pages', app.i18n.locale, params.page).fetch()
      } catch (e) {
        error({ statusCode: 404, message: 'Page not found!' })
      }

      const transformedPage = transformKeysDeep(page)

      return {
        page: transformedPage,
        meta: {
          title: transformedPage.cmsPageTitle,
        },
      }
    },
    head() {
      return createHeadSeoData.call(this)
    },
  }
